import Vue from "vue"
import siteConfig from "@/utils/siteConfig"

export async function requestSignature(fileName, mimeType, category) {
  const formData = new FormData()
  formData.append("filePath", fileName)
  formData.append("contentType", mimeType)
  formData.append("category", category)

  return Vue.axios({
    method: "POST",
    url: `${siteConfig.siteURL}uploads/public`,
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
  // return window.api.post("/uploads/public", formData)
}

export async function uploadToS3(url, signature, file) {
  const formData = new FormData()
  Object.keys(signature).forEach(key => {
    formData.append(`${key}`, signature[key])
  })
  formData.append("file", file)

  return Vue.axios({
    method: "POST",
    url,
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
  // return window.api.post(url, formData)
}
